import { makeObservable, observable, action, autorun, computed } from 'mobx';
import { ContractsIngestionService } from '../services';
import { InputBaseModel } from '../models';
import { SettingsUtils } from '../../custom_shared/misc';
import { BusinessSearchStoreBase, SourceStore } from '../../custom_shared/stores';
import AppStore from './AppStore';
import SessionStore from './SessionStore';

interface InputsToUpdate {
    businessIdInput: InputBaseModel;
    expiringPeriodStartInput: InputBaseModel;
}

export default class BusinessSearchStore extends BusinessSearchStoreBase {
    inputsToUpdate: InputsToUpdate | null = null;

    constructor(
        readonly appStore: AppStore,
        readonly sessionStore: SessionStore,
        readonly sourceStore: SourceStore,
        readonly service: ContractsIngestionService
    ) {
        super(appStore, sourceStore, service);

        makeObservable(this, {
            inputsToUpdate: observable,
            setInputsToUpdate: action,
            isBusinessSearchSupported: computed
        });

        this.reactions.push(
            autorun(r => {
                if (this.sessionStore.isInitializing || !this.isBusinessSearchSupported) {
                    return;
                }

                this.getBusinessPartners();
                r.dispose();
            })
        );
    }

    get isBusinessSearchSupported() {
        return SettingsUtils.ensureSqlScriptIdsConfigured(this.sessionStore.settings, this.sqlScriptIds);
    }

    setInputsToUpdate(inputsToUpdate: InputsToUpdate | null) {
        this.inputsToUpdate = inputsToUpdate;
    }

    initializeSearchModal(businessIdInput: InputBaseModel, expiringPeriodStartInput: InputBaseModel) {
        this.setInputsToUpdate({
            businessIdInput,
            expiringPeriodStartInput
        });

        this.setModalVisible(true);
    }
}
